import { Component, Input, EventEmitter, Output } from '@angular/core';
import { BaseComponent } from '../BaseComponent';
import {
    PlatformService, LoggingService, TokenService,
    LocalStorageService, NotificationsService, PriceService,
    AccountService, Confirmation, TicketsService, TimeService
} from '@varsity/services';
import { PopoverController, ToastController } from 'ionic-angular';
import { DisplayMessageComponent } from '..';
import { interval } from 'rxjs/observable/interval';
import { Observable } from 'rxjs';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the CartIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'cart-icon',
    templateUrl: 'cart-icon.html'
})
export class CartIconComponent extends BaseComponent {
    confirmation: Confirmation;
    @Output() public goToCartHandler: EventEmitter<any> = new EventEmitter();
    @Output() public goToHomePageHandler: EventEmitter<any> = new EventEmitter();
    displayPromoInput: boolean = false;
    cartHasTimer: boolean = false;
    timerDisplayValue: string = " ";
    hasPackages: boolean = false;
    totalNumberOfCartItems: number = 0;

    constructor(
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected priceService: PriceService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected accountService: AccountService,
        protected ticketsService: TicketsService,
        protected timeService: TimeService,
        protected iab: InAppBrowser,

    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "CartIconComponent"
        )
    }

    ngOnInit() {
        super.ngOnInit();

        this.notificationsService.confirmationChanged$
            .takeUntil(this.componentDestroyed$)
            .subscribe((confirmation) => {
                this.confirmation = confirmation;
                this.totalNumberOfCartItems = 0;
                this.loggingService.debug("CART ICON confirmation", this.confirmation);

                if (this.confirmation) {
                    this.hasPackages = (this.confirmation.seasonpasses && this.confirmation.seasonpasses.length > 0);
                    if (this.hasPackages) {
                        this.totalNumberOfCartItems = this.confirmation.seasonpasses.map(p => p.Quantity).reduce((previous, current) => {
                            return previous + current;
                        }, 0) + (this.confirmation.nti || []).map(p => p.OrderAmtQty).reduce((previous, current) => {
                            return previous + current;
                        }, 0);

                    } else {
                        this.totalNumberOfCartItems = (this.confirmation.tickets || []).length + (this.confirmation.nti || []).map(p => p.OrderAmtQty).reduce((previous, current) => {
                            return previous + current;
                        }, 0);
                    }

                    if (this.confirmation.ReserveTimeout) {
                        this.cartHasTimer = true;
                        //interval(1000).subscribe(val => this.timerDisplayValue = this.getTimerDisplayValue());

                        Observable.interval(1000)
                            .takeUntil(this.componentDestroyed$)
                            .subscribe(() => {
                                this.timerDisplayValue = this.getTimerDisplayValue();
                            });
                    }
                }
            });
    }

    goToCart(): void {
        this.goToCartHandler.emit();
    }

    togglePromoInput(): void {
        this.displayPromoInput = !this.displayPromoInput;
    }

    getTimerDisplayValue(): string {
        var displayString = "00:00";
        var remainingTime = 0;
        if (this.confirmation && this.confirmation.ReserveTimeoutLocal) {
            var now = new Date();
            remainingTime = (new Date(this.confirmation.ReserveTimeoutLocal).getTime() - now.getTime()) / 1000;            
            var minutes = Math.floor(remainingTime / 60);
            var seconds = Math.floor(remainingTime % 60);
            // TODO either save extendTimerPopverDisplayed in sessionStorage
            // or move the cart-icon at the same level with the side-menu component

            let extendTimerPopoverDisplayed = false;
            if (this.localStorageService.get("extendTimerPopoverDisplayed")) {
                extendTimerPopoverDisplayed = (this.localStorageService.get("extendTimerPopoverDisplayed") == "true");
            }

            let finalExtendTimerDisplayed = false;
            if (this.localStorageService.get("finalExtendTimerDisplayed")) {
                finalExtendTimerDisplayed = (this.localStorageService.get("finalExtendTimerDisplayed") == "true");
            }

            if (remainingTime > 30 && remainingTime < 60 && !extendTimerPopoverDisplayed) {
                extendTimerPopoverDisplayed = true;

                super.showPopover(DisplayMessageComponent, {
                    icon: "timer",
                    header: "Time is expiring",
                    content: ["The time to complete your transaction is expiring. Do you need additional time?"],
                    buttons: [{ tag: 'no', text: 'No' }, { tag: 'yes', text: 'Yes' }],
                    footer: null,
                }, 'display-message', (d) => {

                    if (d && d.button && d.button.tag == "yes") {
                        this.ticketsService.resetTicketTimeout().subscribe((value) => {
                            if (value) {
                                if (this.confirmation) {
                                    this.confirmation.ReserveTimeoutLocal = this.timeService.getExpirationDateTime(value).toString();
                                    // no need to notify for this
                                    this.localStorageService.add('confirmation', JSON.stringify(this.confirmation));
                                }
                                this.localStorageService.remove("extendTimerPopoverDisplayed");
                            }
                        });
                    }
                }, remainingTime * 1000 - 30000);
            }

            if (remainingTime > 10 && remainingTime < 30 && extendTimerPopoverDisplayed && !finalExtendTimerDisplayed) {
                finalExtendTimerDisplayed = true;
                super.showPopover(DisplayMessageComponent, {
                    icon: "timer",
                    header: "TIME IS EXPIRING!",
                    content: ["Your cart is about to expire. All items will be removed and you will be directed to the home page.", "Do you need additional time?"],
                    buttons: [{ tag: 'no', text: 'No' }, { tag: 'yes', text: 'Yes' }],
                    footer: null,
                }, 'display-message', (d) => {

                    if (d && d.button && d.button.tag == "yes") {
                        this.ticketsService.resetTicketTimeout().subscribe((value) => {
                            if (value) {
                                if (this.confirmation) {
                                    this.confirmation.ReserveTimeoutLocal = this.timeService.getExpirationDateTime(value).toString();
                                    // no need to notify for this
                                    this.localStorageService.add('confirmation', JSON.stringify(this.confirmation));
                                }
                                this.localStorageService.remove("finalExtendTimerDisplayed");
                            }
                        });
                    }
                }, remainingTime * 1000);
            }

            if (this.localStorageService.get("extendTimerPopoverDisplayed") !== extendTimerPopoverDisplayed.toString()) {
                this.localStorageService.add("extendTimerPopoverDisplayed", extendTimerPopoverDisplayed.toString());
            }

            if (this.localStorageService.get("finalExtendTimerDisplayed") !== finalExtendTimerDisplayed.toString()) {
                this.localStorageService.add("finalExtendTimerDisplayed", finalExtendTimerDisplayed.toString());
            }


            if (remainingTime > 0) {
                displayString = ((minutes < 10) ? "0" + minutes.toString() : minutes.toString())
                    + ":"
                    + ((seconds < 10) ? "0" + seconds.toString() : seconds.toString());
            } else {
                this.localStorageService.remove("confirmation");
                this.localStorageService.remove("extendTimerPopoverDisplayed");
                this.localStorageService.remove("finalExtendTimerDisplayed");
                this.localStorageService.remove('useBestSeats');
                this.notificationsService.notifyConfirmationChanged(null);
                this.goToHomePageHandler.emit();
                super.showNotification("Reservation expired, your cart has been cleared.", undefined, false, "notification");
            }

            
            
        }

        return displayString;
    }

}



// WEBPACK FOOTER //
// ./src/components/cart-icon/cart-icon.ts